import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";

const intentConfig = {
  primary: {
    color: "primary",
    fontWeight: 700,
    variant: "contained",
  },
  secondary: {
    color: "primary",
    fontWeight: 600,
    variant: "outlined",
  },
  danger: {
    color: "error",
    fontWeight: 700,
    variant: "contained",
  },
  dangerSoft: {
    color: "error",
    fontWeight: 700,
    variant: "text",
  },
};

export default function ProductButton({
  children,
  color,
  intent = "primary",
  sx,
  variant,
  ...props
}) {
  const config = intentConfig[intent] || intentConfig.primary;
  const resolvedColor = color || config.color;
  const resolvedVariant = variant || config.variant;
  const baseSx = (theme) => ({
    borderRadius: theme.shape.radii.pill,
    boxShadow: "none",
    fontSize: 13,
    fontWeight: config.fontWeight,
    minHeight: 40,
    minWidth: 112,
    px: 2.5,
    textTransform: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      bgcolor:
        resolvedVariant === "contained"
          ? alpha(theme.palette.text.primary, 0.12)
          : undefined,
    },
    ...(intent === "dangerSoft"
      ? {
          bgcolor: alpha(theme.palette.error.main, theme.palette.mode === "dark" ? 0.2 : 0.1),
          border: "1px solid",
          borderColor: alpha(theme.palette.error.main, theme.palette.mode === "dark" ? 0.38 : 0.22),
          "&:hover": {
            bgcolor: alpha(theme.palette.error.main, theme.palette.mode === "dark" ? 0.28 : 0.16),
            borderColor: theme.palette.error.main,
            boxShadow: "none",
          },
        }
      : null),
  });

  return (
    <Button
      color={resolvedColor}
      variant={resolvedVariant}
      sx={Array.isArray(sx) ? [baseSx, ...sx] : [baseSx, sx]}
      {...props}
    >
      {children}
    </Button>
  );
}
